<div *ngIf="isVisible && cookieConsentData" class="cookie-banner" [@sheetUp]="animationState">
  <div class="cookie-banner__container">
    <h4 class="cookie-banner__title">{{ cookieConsentData.title }}</h4>
    <div class="cookie-banner__body" [internalInnerHtml]="cookieConsentData.body" [userEventSource]="userEventSource"></div>
    <div class="button__group">
      <div class="button button--tertiary" role="button" (click)="consentCookies($event, false)">
        <span>{{ "cookies.label.acceptNecessary" | translate }}</span>
      </div>
      <div class="button button--primary" role="button" (click)="consentCookies($event, true)">
        <span>{{ "cookies.label.acceptAll" | translate }}</span>
      </div>
    </div>
  </div>
</div>
